import $ from "jquery";
import * as GC from "../../../../common/common";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";

export default function standart() {}

export const FillTableCallBack = async (result, page_number, columnList) => {
  var oTable = $("#example").dataTable();
  if (page_number === 1) {
    oTable.fnClearTable();
    //that.setState({ tableTotalpages: result.meta.total_pages });
  }
  if (page_number <= result.meta.total_pages) {
    if (result.data.length > 0) {
      for (let i = 0; i < result.data.length; i++) {
        const data = result.data[i];
        var circleType =
          data.content["algemeen-actief"] === true
            ? '<div class="green-circle rounded-circle"><span class="tooltiptext">Actief</span></div>'
            : '<div class="red-circle rounded-circle"><span class="tooltiptext">Inactief</span></div>';
        var algemeenNaam =
          '<span class="text-dark font-weight-bold">' +
          data.content["algemeen-naam"] +
          "</span>";
        var algemeenCode = data.content["algemeen-code"];
        if (typeof algemeenCode === "undefined") {
          algemeenCode = "";
        } else
          algemeenCode =
            '<a href="javascript:void(0)">' +
            data.content["algemeen-code"] +
            "</a>";
        var checkbox =
          '<label class="ct-checkbox"><input type="checkbox"><span class="checkmark"></span></label>';

        var omschrijving = data.content["algemeen-omschrijving"];
        if (typeof omschrijving === "undefined") {
          omschrijving = "";
        }
        var status = data.content["algemeen-status"];
        if (typeof status === "undefined") {
          status = "";
        }
        var compleet =
          data.content["algemeen-compleet"] === true
            ? '<div class="green-circle rounded-circle"><span class="tooltiptext">Deze beheereenheşd is actief</span></div>'
            : '<div class="red-circle rounded-circle"><span class="tooltiptext">Deze beheereenheşd is inactief</span></div>';
        var datumAangemaakt = data["timestamp_created"];
        if (typeof datumAangemaakt === "undefined") {
          datumAangemaakt = "";
        } else datumAangemaakt = GC.FormatDate(datumAangemaakt, "date");
        var datumLaatstGewijzigd = data["timestamp_any_update"];
        if (typeof datumLaatstGewijzigd === "undefined") {
          datumLaatstGewijzigd = "";
        } else {
          datumLaatstGewijzigd = GC.FormatDate(datumLaatstGewijzigd, "date");
        }

        var aantalbijlagen = data.content["algemeen-aantalbijlagen"];
        if (typeof aantalbijlagen === "undefined") {
          aantalbijlagen = "";
        }

        var model = {
          algemeenNaam: data.content["algemeen-naam"],
          algemeenCode: data.content["algemeen-code"],
          omschrijving: data.content["algemeen-omschrijving"],
          status: data.content["algemeen-status"],
          compleet: data.content["algemeen-compleet"],
          aantalbijlagen: aantalbijlagen,
          datumAangemaakt: datumAangemaakt,
          datumLaatstGewijzigd: datumLaatstGewijzigd,
          isActive: data.content["algemeen-actief"],
          identification: data["identification"],
        };

        var test = {
          checkbox: checkbox,
          active: circleType,
          "Naam werkplan": algemeenNaam,
          Code: algemeenCode,
          Omschrijving: omschrijving,
          Status: status,
          Compleet: compleet,
          paperclip: aantalbijlagen,
          "Datum aangemaakt": datumAangemaakt,
          "Datum laatst gewijzigd": datumLaatstGewijzigd,
        };

        let _columnList = [];
        if (columnList && columnList.column_list){
          for (let column in columnList.column_list) {
            for (let key in test) {
              if (
                  columnList.column_list[column].toLowerCase() === key.toLowerCase()
              ) {
                _columnList.push(test[key]);
              }
            }
          }
        }

        window.$catalog_work_plans_Glist.push(model);
        var addId = oTable.fnAddData(
          [
            ..._columnList,
            // checkbox,
            // circleType,
            // algemeenNaam,
            // algemeenCode,
            // omschrijving,
            // status,
            // compleet,
            // aantalbijlagen,
            // datumAangemaakt,
            // datumLaatstGewijzigd,
          ],
          false
        );

        if(addId.length > 0) {
          var theNode = $("#example").dataTable().fnSettings().aoData[
              addId[0]
              ].nTr;
          theNode.setAttribute("rowId", data["identification"]);
        }
      }

      // await $.each(result.data, async function (index, data) {
      //   var circleType =
      //     data.content["algemeen-actief"] === true
      //       ? '<div class="green-circle rounded-circle"><span class="tooltiptext">Actief</span></div>'
      //       : '<div class="red-circle rounded-circle"><span class="tooltiptext">Inactief</span></div>';
      //   var algemeenNaam =
      //     '<span class="text-dark font-weight-bold">' +
      //     data.content["algemeen-naam"] +
      //     "</span>";
      //   var algemeenCode = data.content["algemeen-code"];
      //   if (typeof algemeenCode === "undefined") {
      //     algemeenCode = "";
      //   } else algemeenCode = '<a href="javascript:void(0)">' + data.content["algemeen-code"] + "</a>";
      //   var checkbox =
      //     '<label class="ct-checkbox"><input type="checkbox"><span class="checkmark"></span></label>';

      //   var omschrijving = data.content["algemeen-omschrijving"];
      //   if (typeof omschrijving === "undefined") {
      //     omschrijving = "";
      //   }
      //   var status = data.content["algemeen-status"];
      //   if (typeof status === "undefined") {
      //     status = "";
      //   }
      //   var compleet =
      //     data.content["algemeen-compleet"] === true
      //       ? '<div class="green-circle rounded-circle"><span class="tooltiptext">Deze beheereenheşd is actief</span></div>'
      //       : '<div class="red-circle rounded-circle"><span class="tooltiptext">Deze beheereenheşd is inactief</span></div>';
      //   var datumAangemaakt = data["timestamp_created"];
      //   if (typeof datumAangemaakt === "undefined") {
      //     datumAangemaakt = "";
      //   } else datumAangemaakt = GC.FormatDate(datumAangemaakt, "date");
      //   var datumLaatstGewijzigd = data["timestamp_any_update"];
      //   if (typeof datumLaatstGewijzigd === "undefined") {
      //     datumLaatstGewijzigd = "";
      //   } else datumLaatstGewijzigd = GC.FormatDate(datumLaatstGewijzigd, "date");
      //   let mediaResult;
      //   await omnimap
      //     .GetMediaListAction(
      //       { path: "" },
      //       data.identification,
      //       window.$catalog_management_units_token
      //     )
      //     .then((result) => {
      //       mediaResult = result.data.files.length;
      //     });
      //   var model = {
      //     algemeenNaam: data.content["algemeen-naam"],
      //     algemeenCode: data.content["algemeen-code"],
      //     omschrijving: data.content["algemeen-omschrijving"],
      //     status: data.content["algemeen-status"],
      //     compleet: data.content["algemeen-compleet"],
      //     mediaResult: mediaResult,
      //     datumAangemaakt: datumAangemaakt,
      //     datumLaatstGewijzigd: datumLaatstGewijzigd,
      //     isActive: data.content["algemeen-actief"],
      //     identification: data["identification"],
      //   };
      //   window.$catalog_work_plans_Glist.push(model);
      //   var addId = oTable.fnAddData(
      //     [
      //       checkbox,
      //       circleType,
      //       algemeenNaam,
      //       algemeenCode,
      //       omschrijving,
      //       status,
      //       compleet,
      //       null,
      //       datumAangemaakt,
      //       datumLaatstGewijzigd,
      //     ],
      //     false
      //   );

      //   var theNode = $("#example").dataTable().fnSettings().aoData[addId[0]]
      //     .nTr;
      //   theNode.setAttribute("rowId", data["identification"]);
      // });
      await oTable.fnDraw();
    } else {
      $("tbody").html();
      oTable.fnClearTable();
    }
  }
  //that.setState({ tableTotalpage: result.meta.total_pages });

  $("#total-rows").html(result.meta.total_found);
  window.$catalog_work_plans_table_total_row_count = result.meta.total_found;
  $("#cover-spin").hide(0);
  window.$catalog_work_plans_treeChangeStatus = true;
  window.$catalog_work_plans_scroll_change = true;
};

export const FillFilterColumnsCallBack = (data, result) => {
  if (data.id === "algemeen-code") {
    $.each(result.data.values, function (index, data) {
      window.$catalog_work_plans_algemeenCode.push(data);
    });
  } else if (data.id === "algemeen-naam") {
    $.each(result.data.values, function (index, data) {
      window.$catalog_work_plans_algemeenNaam.push(data);
    });
  } else if (data.id === "algemeen-status") {
    $.each(result.data.values, function (index, data) {
      window.$catalog_work_plans_algemeenStatus.push(data);
    });
  } else if (data.id === "algemeen-omschrijving") {
    $.each(result.data.values, function (index, data) {
      window.$catalog_work_plans_algemeenOmschrijving.push(data);
    });
  }
};

export const SearchFilterColumnsCallBack = (searchId, result) => {
  if (searchId === "algemeen-naam") {
    console.log(result.data.values);
    window.$catalog_work_plans_algemeenNaam.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$catalog_work_plans_algemeenNaam.push(data);
    });
  } else if (searchId === "algemeen-code") {
    window.$catalog_work_plans_algemeenCode.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$catalog_work_plans_algemeenCode.push(data);
    });
  } else if (searchId === "algemeen-status") {
    window.$catalog_work_plans_algemeenStatus.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$catalog_work_plans_algemeenStatus.push(data);
    });
  } else if (searchId === "algemeen-omschrijving") {
    window.$catalog_work_plans_algemeenOmschrijving.length = 0;
    $.each(result.data.values, function (index, data) {
      window.$catalog_work_plans_algemeenOmschrijving.push(data);
    });
  }
};

export const RowsDeletedCallBack = (token) => {
  GC.sleep(800).then(() => {
    $("#work-plans-mappen_beheren_delete_modal").modal("hide");
    window.$catalog_work_plans_refresh();
    /*omnimap
      .FillTableAction(window.$catalog_work_plans_lastUsedTableFilter, 1, token)
      .then((result) => {
        FillTableCallBack(result, 1);
      });*/
  });
};

export const GetColumnPropertiesCallBack = (data, callType) => {
  var filteredRes = data.data.find((item, i) => {
    if (item.identification === process.env.REACT_APP_CATALOG_MEASURES) {
      return i;
    }
  });

  // var result_data =
  //   data.data[process.env.REACT_APP_NODE_ENV == "staging" ? 9 : 2].schema
  //     .properties.algemeen.properties;
  var result_data = filteredRes.schema.properties.algemeen.properties;
  window.$catalog_work_plans_column_list.forEach(function (item) {
    // if (item.haveSelect && item.selectProperties != null) {
    //   if (callType == "create") {
    //     const selectStatus = document.getElementById(item.createId);
    //     while (selectStatus.firstChild) {
    //       selectStatus.removeChild(selectStatus.lastChild);
    //     }
    //     var option = document.createElement("option");
    //     option.text = "Selecteer";
    //     option.style = "display:none;";
    //     selectStatus.add(option);
    //     result_data[item.selectProperties].enum.forEach((element) => {
    //       var option = document.createElement("option");
    //       option.text = element;
    //       option.value = element;
    //       selectStatus.add(option);
    //     });
    //   } else if (callType == "edit") {
    //     const editSelectStatus = document.getElementById(item.editId);
    //     if (editSelectStatus && editSelectStatus.firstChild != null) {
    //       while (editSelectStatus.firstChild) {
    //         editSelectStatus.removeChild(editSelectStatus.lastChild);
    //       }
    //     }
    //     result_data[item.selectProperties].enum.forEach((element) => {
    //       if (item.editId) {
    //         var option = document.createElement("a");
    //         option.attributes.href = "javascript:void(0)";
    //         option.className = "popuptext-dropdown-a";
    //         option.name = item.editId;
    //         option.innerText = element;
    //         editSelectStatus.appendChild(option);
    //       }
    //     });
    //   }
    // }
  });
};

export const GetColumnPropertiesForModelCallBack = (
  result,
  itemId,
  callType
) => {
  window.$catalog_measures_column_list.forEach(function (item) {
    if (item.id === itemId) {
      if (callType == "create") {
        const selectStatus = document.getElementById(item.createId);
        while (selectStatus.firstChild) {
          selectStatus.removeChild(selectStatus.lastChild);
        }
        var option = document.createElement("option");
        option.text = "Selecteer";
        option.style = "display:none;";
        selectStatus.add(option);
        result.data.forEach((element) => {
          var option = document.createElement("option");
          option.text = element.name;
          option.value = element.identification;
          selectStatus.add(option);
        });
      } else if (callType == "edit") {
        const editSelectStatus = document.getElementById(item.editId);
        if (editSelectStatus && editSelectStatus.firstChild != null) {
          while (editSelectStatus.firstChild) {
            editSelectStatus.removeChild(editSelectStatus.lastChild);
          }
        }
        result.data.forEach((element) => {
          if (item.editId) {
            var option = document.createElement("a");
            option.attributes.href = "javascript:void(0)";
            option.className = "popuptext-dropdown-a";
            option.name = item.editId;
            option.innerText = element.name;
            option.id = element.identification;
            editSelectStatus.appendChild(option);
          }
        });
      }
    }
  });
};

export const GetActionsOfRowCallback = (result, roleBasedActionList) => {
  const actionsOfSelection = [];
  //var actionsOfDisabled = [];

/*  const filteredArray = result.data.stages.filter((value) =>
    roleBasedActionList.includes(value.definition.identification)
  );*/

/*  $.each(filteredArray, function (index, stage) {
    if (stage.definition.type === "activity" && stage.start_allowed === true) {
      actionsOfSelection.push(stage.definition.identification);
    } else {
      actionsOfDisabled.push(stage.definition);
    }
  });*/





  if (window.$catalog_work_plans_selectedIds.length > 0) {
  //if (result.data.stages.length > 0) {

/*
    //!** aktif olmayan actionlar burada listeleniyor. *!/
    $.each(actionsOfDisabled, function (index, action) {
      var anchor = $("<a disabled></a>")
          .attr({ href: "javascript:void(0)", id: action["identification"] })
          .addClass("disabled" + " catalog-action")
          .html(action["name"]);
      $("#myPopup").append(anchor);
    });
*/
    //actionsOfDisabled=[]
    $("#myPopup").html("");
    $.each(window.$catalog_work_plans_actions, function (index, action) {
      if ($.inArray(action["id"], roleBasedActionList) !== -1) {
        var anchor = $("<a></a>")
            .attr({ href: "javascript:void(0)", id: action["id"] })
            .addClass(action["class"] + " work-plans-catalog-action")
            .html(action["text"]);
        $("#myPopup").append(anchor);
      } else {
        var anchor = $("<a></a>")
            .attr({ href: "javascript:void(0)", id: action["id"] })
            .addClass(action["class"] + " work-plans-catalog-action")
            .html(action["text"]);
        $("#myPopup").append(anchor);

        //actionsOfDisabled.push({name:action['text'], identification:action["id"]})
      }
    });


    var verwijderen = $("<a></a>")
      .attr({ href: "javascript:void(0)", id: "work-plans-verwijderen" })
      .addClass("trash-bin beheereenheid")
      .html("Verwijderen");
    $("#myPopup").append(verwijderen);
  } else {
    var beheereenheidToevoegen = $("<a></a>")
      .attr({ href: "javascript:void(0)", id: "werkplann_toevoegen" })
      .addClass("locate beheereenheid")
      .html("Werkplan toevoegen");
    $("#myPopup").append(beheereenheidToevoegen);

    var mapAanmaken = $("<a></a>")
      .attr({ href: "javascript:void(0)", id: "work_plans_map_aanmaken" })
      .addClass("folder-popup beheereenheid")
      .html("Map aanmaken");
    $("#myPopup").append(mapAanmaken);
  }

  var popup = document.getElementById("myPopup");
  popup.classList.toggle("show");
};

export const WerkplanSavedCallBack = (token, id) => {
  GC.sleep(1000).then(() => {
    var model = {
      action: "ADD",
      contextRol: "Werkplan zit in folder",
      folder: document.getElementById("tree-parent-id").value,
    };
    GC.StartActivity(
      model,
      [id],
      "8c5da794-f8da-4549-9b48-f7123c59642a",
      werkplanSavedNext(token),
      token
    );
  });
};
function werkplanSavedNext(token) {
  GC.sleep(2000).then(() => {
    $("#werkplannen_toevoegen_modal").modal("hide");
    window.$catalog_work_plans_refresh();
    /*omnimap
      .FillTableAction(window.$catalog_work_plans_lastUsedTableFilter, 1, token)
      .then((result) => {
        FillTableCallBack(result, 1);
      });*/
  });
}

// export const WerkplanSaved = () => {
//   GC.sleep(800).then(() => {
//     $("#werkplannen_toevoegen_modal").modal("hide");
//     omnimap
//       .FillTableAction(
//         window.$catalog_work_plans_lastUsedTableFilter,
//         1,
//         window.$catalog_management_units_token
//       )
//       .then((result) => {
//         FillTableCallBack(result, 1);
//       });
//   });
// };

export const BeheereenheidEdit = () => {
  GC.sleep(800).then(() => {
    $("#detailSide").addClass("d-none");
    $("#editSide").addClass("d-none");
    $("#tableSide").removeClass("d-none");
    window.$catalog_work_plans_refresh();
    /*omnimap
      .FillTableAction(
        window.$catalog_work_plans_lastUsedTableFilter,
        1,
        window.$catalog_management_units_token
      )
      .then((result) => {
        FillTableCallBack(result, 1);
      });*/
  });
};

export const DirectievoerderCallbackForCreate = (
  result,
  userRegisteredRoles = [],
  _userRegisteredRoles
) => {
  const selectStatus = document.getElementById("werkplan-directievoerder");
  while (selectStatus.firstChild) {
    selectStatus.removeChild(selectStatus.lastChild);
  }

  userRegisteredRoles.forEach((el) => {
    if (el.role === "Directievoerder") {
      _userRegisteredRoles = el.relationships.related_instance.identification;
    }
  });

  var option = document.createElement("option");
  option.text = "Selecteer";
  option.value = 0;
  // option.style = "display:none;";
  selectStatus.add(option);

  if (result.length > 0) {
    result.forEach((element) => {
      if (element.identification === _userRegisteredRoles) {
        var option = document.createElement("option");
        option.text = element.alias;
        option.selected = true;
        option.value = element.identification;
        selectStatus.add(option);
      } else {
        var option = document.createElement("option");
        option.text = element.alias;
        option.value = element.identification;
        selectStatus.add(option);
      }
    });
  }
};

export const ToevoegenToezichthouderCallbackForCreate = (
  result,
  userRegisteredRoles,
  id,
  name,
  _userRegisteredRoles = []
) => {
  userRegisteredRoles.forEach((el) => {
    if (el.role.toLowerCase() === name.toLowerCase()) {
      _userRegisteredRoles.push(
        el.relationships.related_instance.identification
      );
    }
  });

  $("#" + id).html("");

  result.data.forEach((row) => {
    if (_userRegisteredRoles.indexOf(row.identification) !== -1) {
      var btn = '<div class="custom-control custom-checkbox">';
      btn +=
        '<input type="checkbox" checked class="custom-control-input" name="' +
        name +
        '"  id="' +
        row["identification"] +
        '" value="' +
        row["identification"] +
        '"/>';
      btn +=
        '<label class="custom-control-label" for="' +
        row["identification"] +
        '">' +
        row["alias"] +
        "</label></div>";
      $("#" + id).append(btn);
    } else {
      var btn = '<div class="custom-control custom-checkbox">';
      btn +=
        '<input type="checkbox" class="custom-control-input" name="' +
        name +
        '"  id="' +
        row["identification"] +
        '" value="' +
        row["identification"] +
        '"/>';
      btn +=
        '<label class="custom-control-label" for="' +
        row["identification"] +
        '">' +
        row["alias"] +
        "</label></div>";
      $("#" + id).append(btn);
    }
  });

  // $.each(result.data, function (index, row) {
  //   var btn = '<div class="custom-control custom-checkbox">';
  //   btn +=
  //     '<input type="checkbox" class="custom-control-input" name="' +
  //     name +
  //     '"  id="' +
  //     row["identification"] +
  //     '" value="' +
  //     row["identification"] +
  //     '"/>';
  //   btn +=
  //     '<label class="custom-control-label" for="' +
  //     row["identification"] +
  //     '">' +
  //     row["alias"] +
  //     "</label></div>";
  //   $("#" + id).append(btn);
  // });
};
export function TableColumnChangeHandler(
  settings,
  data,
  identification,
  columnOrderReference,
  COLUMN_ORDER_CATALOG_MANAGEMENT_UNIT
) {
  var names = settings.aoColumns;
  if (names[0]) {
  }
  var test_list = [];
  names.forEach((element, index) => {
    test_list.push(element.sTitle);
  });

  var checkIndex = test_list.findIndex((x) => x.includes("checkAll"));
  test_list[checkIndex] = "checkbox";
  var statusIndex = test_list.findIndex((x) => x.includes("snowflake"));
  test_list[statusIndex] = "active";
  var statusIndex = test_list.findIndex((x) => x.includes("bijlage"));
  test_list[statusIndex] = "paperclip";
  var model = {
    identification: identification,
    code: COLUMN_ORDER_CATALOG_MANAGEMENT_UNIT,
    client_identification: COLUMN_ORDER_CATALOG_MANAGEMENT_UNIT,
    reference: columnOrderReference,
    data: {
      table_sorting: [
        {
          name: "catalog>work-plans",
          column_list: [],
        },
      ],
    },
  };
  var asd = (model.data.table_sorting.find(
    (x) => x.name === "catalog>work-plans"
  ).column_list = test_list);
  omnimap.GetFreeFormatAction(identification, "PUT", model);

  return model.data.table_sorting[0];
}
